import { gql } from 'graphql-request'

export const siteEnableTanningFeaturesQuery = gql`
  query SiteEnableTanningFeatures($siteId: ID!) {
    site(siteId: $siteId) {
      siteId
      adminConfigurations {
        enableTanningFeatures
      }
      integrations {
        tanning {
          externalApiUrl
        }
      }
    }
  }
`

export const siteTanningMaintenanceEmailQuery = gql`
  query SiteTanningMaintenanceEmail($siteId: ID!) {
    site(siteId: $siteId) {
      siteId
      integrations {
        tanning {
          maintenanceEmail
        }
      }
    }
  }
`
